function Unauthorized() {
  return (
    <div className="text-center mt-5">
      <h2>403 - Access Denied</h2>
      <p>You are not allowed to access this page.</p>

      <a href="/Login">Got To Home</a>
    </div>
  );
}

export default Unauthorized;